import useScrollLock from '@hooks/useBodyScrollLock';
import { ReactComponent as SvgChevronRight } from '@img/icons/chevron-right.svg';
import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import noop from 'lodash/noop';
import React from 'react';
import PostcodeModal from '../Modals/PostcodeModal/PostcodeModal';
import S from './APLFiltersMobile.styles';
import FilterList from './List/FilterList';
import SelectedList from './SelectedList/SelectedList';
import SelectedRadioList from './SelectedRadioList/SelectedRadioList';
const APLFiltersMobile = ({ professionFilters, countyFilters, servicesFilters, countyValues, professionValues, servicesValues, onFilterChange, onPostcodeSearch = noop, onPostcodeSubmit = noop, showPostcodeModal = false, postcodeValue, onPostcodeModalClose = noop, onClearPostcode = noop, onClearAllFilters = noop, sortByOptions, sortByValue, onSortChange = noop, }) => {
    const ref = React.useRef(null);
    const [activeFilters, setActiveFilters] = React.useState();
    const [activeValues, setActiveValues] = React.useState();
    const [visible, setVisible] = React.useState(false);
    const totalSelected = [professionValues, countyValues, servicesValues].flat().length;
    useScrollLock(ref.current, visible);
    return (React.createElement(S.Container, { "aria-active": visible },
        React.createElement(S.Open, { onClick: (event) => {
                event.preventDefault();
                setVisible(true);
            } },
            React.createElement("span", null,
                "Filters",
                totalSelected > 0 ? React.createElement("strong", null,
                    ": ",
                    totalSelected,
                    " selected") : null),
            React.createElement(SvgChevronRight, null)),
        React.createElement(S.Overlay, { ref: ref },
            React.createElement(S.Close, { onClick: (event) => {
                    event.preventDefault();
                    setActiveFilters(undefined);
                    setVisible(false);
                } },
                React.createElement(SvgClose, null),
                React.createElement("span", null, "Close")),
            activeFilters === undefined ? renderTopLevelList() : renderActiveList()),
        React.createElement(S.Background, { onClick: (event) => {
                event.preventDefault();
                setActiveFilters(undefined);
                setVisible(false);
            } }),
        React.createElement(PostcodeModal, { visible: showPostcodeModal, onClose: onPostcodeModalClose, onSubmit: onPostcodeSubmit })));
    function renderTopLevelList() {
        return (React.createElement(FilterList, { title: "Filters", professionFilters: professionFilters, countyFilters: countyFilters, servicesFilters: servicesFilters, professionValues: professionValues, countyValues: countyValues, servicesValues: servicesValues, postcodeValue: postcodeValue, onApply: () => {
                setActiveFilters(undefined);
                setActiveValues(undefined);
                setVisible(false);
            }, onClearPostcode: onClearPostcode, onPostcodeSearch: onPostcodeSearch, onRemove: () => {
                onClearAllFilters();
            }, onSelect: (filters, values) => {
                setActiveFilters(filters);
                setActiveValues(values);
            } }));
    }
    function renderActiveList() {
        if (activeFilters === undefined) {
            return React.createElement("div", null);
        }
        let selectedValues = [];
        switch (activeValues) {
            case 'profession':
                selectedValues = professionValues;
                break;
            case 'county':
                selectedValues = countyValues;
                break;
            case 'services':
                selectedValues = servicesValues;
                break;
            case 'sortBy':
                return (React.createElement(React.Fragment, null,
                    React.createElement(SelectedRadioList, { name: "sortBy", selectedFilters: sortByOptions, selectedValue: sortByValue, onFilterChange: onSortChange, title: 'Sort by', onCancel: () => {
                            setActiveFilters(undefined);
                        } })));
        }
        return (React.createElement(SelectedList, { selectedFilters: activeFilters, selectedValues: selectedValues, onFilterChange: onFilterChange, title: activeFilters.title ?? '', onCancel: () => {
                setActiveFilters(undefined);
            }, onClear: () => {
                setActiveFilters(undefined);
                onFilterChange(activeFilters.key, []);
            } }));
    }
};
export default APLFiltersMobile;
